import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento_tatico', 'planejamento-tatico-material');

const planejamentoActions = {
  listar: { method: 'GET', url: `${basePath}/{idPlanejamento}` },
  listarPorAcao: { method: 'GET', url: `${basePath}/acao/{idPlanejamentoAcao}` },
  salvar: { method: 'POST', url: `${basePath}` },
  salvarPorAcao: { method: 'POST', url: `${basePath}/acao` },
  buscarSaldoMateriais: { method: 'GET', url: `${basePath}/saldo/{idPlanejamento}` },
};

export default resource => resource(`${basePath}`, {}, planejamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-tatico-material.js